const GLOBAL_RULES_PATH = '/global-rules';
const OVERRIDES_PATH = '/overrides';
const OVERRIDES_MERCHANT_PATH = `${OVERRIDES_PATH}/merchant`;
const REPORTS_PATH = '/reports';
const SIMULATIONS_PATH = '/simulations';
const REVISIONS_PATH = '/revisions';
const LIST_MANAGEMENT_PATH = '/list-management';
const TENANTS_PATH = '/tenants';
const PARAMETERS_PATH = '/parameters';
const RULE_GROUP_CONDITIONS_PATH = '/rule-group';
const RULE_TESTS_PATH = '/rule-tests';

export const ROUTES = {
    GLOBAL_RULES: {
        INDEX: GLOBAL_RULES_PATH,
        DEPLOYED_TENANT: `${GLOBAL_RULES_PATH}/deployed/tenant`,
        DEPLOYED_LANDLORD: `${GLOBAL_RULES_PATH}/deployed/landlord/:viewMode`,
        DEPLOYED_LANDLORD_OVERRIDE: `${GLOBAL_RULES_PATH}/deployed/landlord/overrides`,
        DEPLOYED_LANDLORD_OVERRIDE_ADD: `${GLOBAL_RULES_PATH}/deployed/landlord/override`,
        BULK_UPLOAD: `${GLOBAL_RULES_PATH}/bulk-upload`,
        UPDATE_DEFAULT_RULE_PAGE: `${GLOBAL_RULES_PATH}/edit-rule/:ruleId`,
        CREATE_SIMPLE_RULE_PAGE: `${GLOBAL_RULES_PATH}/create-rule`,
        UPDATE_SIMPLE_RULE_PAGE: `${GLOBAL_RULES_PATH}/adhoc/edit-rule/:ruleId`,
        CREATE_ADVANCED_RULE_PAGE: `${GLOBAL_RULES_PATH}/create-advanced-rule`,
        UPDATE_ADVANCED_RULE_PAGE: `${GLOBAL_RULES_PATH}/adhoc/edit-advanced-rule/:ruleId`,
        VIEW_RULE_TEST: `${GLOBAL_RULES_PATH}/rule-tester/view/:ruleId`,
        CREATE_RULE_GROUP_CONDITIONS: `${GLOBAL_RULES_PATH}${RULE_GROUP_CONDITIONS_PATH}/create`,
        UPDATE_RULE_GROUP_CONDITIONS: `${GLOBAL_RULES_PATH}${RULE_GROUP_CONDITIONS_PATH}/edit/:ruleGroupId`
    },
    OVERRIDES: {
        INDEX: OVERRIDES_PATH,
        BULK_UPLOAD: `${OVERRIDES_PATH}/bulk-upload`
    },
    OVERRIDES_MERCHANT: {
        INDEX: OVERRIDES_MERCHANT_PATH,
        MID: `${OVERRIDES_MERCHANT_PATH}/:mid`,
        MID_DEPLOYED: `${OVERRIDES_MERCHANT_PATH}/:mid/deployed`,
        RULES_EDIT_OVERRIDE: `${OVERRIDES_MERCHANT_PATH}/:mid/edit-merchant-override/:ruleId`,
        RULES_ADD_OVERRIDE: `${OVERRIDES_MERCHANT_PATH}/:mid/add-merchant-override/:ruleId`
    },
    OVERRIDES_TENANT_RULES_EDIT_OVERRIDE: `${GLOBAL_RULES_PATH}/deployed/landlord/override/edit/:ruleId`,
    OVERRIDES_TENANT_RULES_ADD_OVERRIDE: `${GLOBAL_RULES_PATH}/deployed/landlord/override/add/:ruleId`,
    PARAMETERS: {
        INDEX: PARAMETERS_PATH,
        CREATE_NEW_EXPRESSION_PAGE: `${PARAMETERS_PATH}/create-expression`,
        CREATE_NEW_VELOCITY_PAGE: `${PARAMETERS_PATH}/create-velocity`,
        EDIT_VELOCITY: `${PARAMETERS_PATH}/edit-velocity/:parameterId`,
        EDIT_EXPRESSION: `${PARAMETERS_PATH}/edit-expression/:parameterId`,
        VIEW_EXPRESSION: `${PARAMETERS_PATH}/view-expression/:parameterId`
    },
    TENANTS: {
        INDEX: TENANTS_PATH,
        TENANT_GROUP: `${TENANTS_PATH}/tenant-group/:tenantGroupId`,
        TENANT_GROUP_DEPLOYED: `${TENANTS_PATH}/tenant-group/:tenantGroupId/deployed`,
        TENANT_GROUP_ADD_TENANT: `${TENANTS_PATH}/tenant-group/:tenantGroupId/add-tenant`,
        TENANT_GROUP_OVERRIDE: `${TENANTS_PATH}/tenant-group/:tenantGroupId/verrides`,
        TENANT_GROUP_OVERRIDES_LANDLORD_RULES: `${TENANTS_PATH}/tenant-group/:tenantGroupId/overrides`,
        TENANT_GROUP_EDIT_OVERRIDE: `${TENANTS_PATH}/tenant-group/:tenantGroupId/edit-tenant-group-override/:ruleId`,
        TENANT_GROUP_ADD_OVERRIDE: `${TENANTS_PATH}/tenant-group/:tenantGroupId/add-tenant-group-override/:ruleId`,
        IMPERSONATE_TENANT: `${TENANTS_PATH}/list/:list?`
    },
    SIMULATIONS: {
        INDEX: SIMULATIONS_PATH,
        SIMULATION: `${SIMULATIONS_PATH}/:id`
    },
    REPORTS: REPORTS_PATH,
    NEW_REPORT: {
        MERCHANT_SUMMARY: `${REPORTS_PATH}/new-merchantsummary-report`,
        RULE_PERFORMANCE: `${REPORTS_PATH}/new-performance-report`
    },
    SAVED_REPORT: {
        MERCHANT_SUMMARY: `${REPORTS_PATH}/merchantsummary/:rid`,
        RULE_PERFORMANCE: `${REPORTS_PATH}/performance/:rid`
    },
    REVISIONS: REVISIONS_PATH,
    SCHEDULED_REVISION_WINDOW: `${REVISIONS_PATH}/scheduled/:version`,
    SINGLE_REVISION_WINDOW: `${REVISIONS_PATH}/:version`,
    LIST_MANAGEMENT: {
        INDEX: LIST_MANAGEMENT_PATH,
        LIST: `${LIST_MANAGEMENT_PATH}/:id`,
        BULK_UPLOAD: `${LIST_MANAGEMENT_PATH}/:id/bulk-upload`,
        IMPORT_ENTRIES: `${LIST_MANAGEMENT_PATH}/:id/import-entries`,
        REMOVED_LIST_ENTRIES: `${LIST_MANAGEMENT_PATH}/:id/removed-list-entries`
    },
    RULE_TESTS: {
        INDEX: RULE_TESTS_PATH
    }
};
